import { createUseStyles } from 'react-jss';

import { PricingAppTheme } from '~app/styles/pricing/types';
import { MD_MEDIA_QUERY } from '~shared/media-query';

export default createUseStyles(({ spacing }: PricingAppTheme) => ({
  Summary: {
    margin: [spacing[8], 'auto', 0],
  },
  PackagesContainer: {
    display: 'grid',
    padding: [0, spacing[3]],
    [MD_MEDIA_QUERY]: {
      display: 'flex',
      justifyContent: 'center',
    },
  },
}));
